/**
 * Authentication Flow Event Tracking
 * Tracks auth failures, recoveries, and session issues
 */

import { posthog } from '../posthog'

export const authEvents = {
  /** PKCE code verifier missing/invalid – user opened link in different browser or cookie was lost */
  pkceFailure(props: {
    error_code?: string
    error_message?: string
    browser_class?: string
    has_code_verifier?: boolean
    user_agent?: string
  }) {
    posthog.capture('auth_pkce_failure', { ...props, timestamp_ms: Date.now() })
  },

  /** Magic link callback succeeded */
  callbackSuccess(props: { flow_type: 'code' | 'token_hash'; provider_type?: string }) {
    posthog.capture('auth_callback_success', { ...props, timestamp_ms: Date.now() })
  },

  /** Magic link callback failed (non-PKCE errors) */
  callbackFailure(props: {
    flow_type: 'code' | 'token_hash'
    error_code?: string
    error_message?: string
    browser_class?: string
    has_code_verifier?: boolean
  }) {
    posthog.capture('auth_callback_failure', { ...props, timestamp_ms: Date.now() })
  },

  /** User entered the PKCE recovery flow (shown the recovery UI) */
  recoveryFlowEntered(props?: { source?: string }) {
    posthog.capture('auth_recovery_flow_entered', { ...props, timestamp_ms: Date.now() })
  },

  /** OTP verification succeeded */
  otpSuccess(props: { is_new_user: boolean }) {
    posthog.capture('auth_otp_success', { ...props, timestamp_ms: Date.now() })
  },

  /** OTP verification failed */
  otpFailure(props: { is_new_user: boolean; error_message?: string }) {
    posthog.capture('auth_otp_failure', { ...props, timestamp_ms: Date.now() })
  },

  /** Session expired – auth error detected in middleware */
  sessionExpired(props: { error_code: string; path: string }) {
    posthog.capture('auth_session_expired', { ...props, timestamp_ms: Date.now() })
  },

  /** Magic link was sent */
  magicLinkSent(props: { is_new_user: boolean }) {
    posthog.capture('auth_magic_link_sent', { ...props, timestamp_ms: Date.now() })
  },

  /** Google sign-in initiated */
  googleSignInStarted() {
    posthog.capture('auth_google_signin_started', { timestamp_ms: Date.now() })
  },
}
